// The key usages for AEAD.
export const AEAD_USAGES = ["encrypt", "decrypt"];
